import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/LanguageContext";

const reveal = {
  hidden: { opacity: 0, y: 50 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function Philosophy() {
  const { t } = useI18n();
  const intro = [
    t.philosophy.i1,
    t.philosophy.i2,
    t.philosophy.i3,
    t.philosophy.i4,
  ];
  const principles = [
    { num: "01", text: t.philosophy.p1 },
    { num: "02", text: t.philosophy.p2 },
    { num: "03", text: t.philosophy.p3 },
  ];

  return (
    <section
      id="philosophy"
      className="relative z-10 scroll-mt-24 border-t border-white/10 bg-[#050505] px-6 pt-32 pb-24 sm:pl-[120px] sm:pr-16"
      data-testid="philosophy-section"
    >
      <span className="font-mono-accent text-[11px] uppercase tracking-[0.3em] text-[#a855f7]">
        [ 02 — {t.sections.philosophy} ]
      </span>

      <motion.h2
        variants={reveal}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
        className="mt-8 max-w-[20ch] font-head text-4xl font-light leading-[1.05] tracking-tight text-white sm:text-6xl"
      >
        {t.philosophy.headA}
        <span className="text-white/40"> {t.philosophy.headB}</span>
      </motion.h2>

      <div className="mt-16 grid max-w-3xl grid-cols-1 gap-6">
        {intro.map((p, i) => (
          <motion.p
            key={i}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-50px" }}
            className="font-body text-base leading-relaxed text-white/60"
          >
            {p}
          </motion.p>
        ))}
      </div>

      <p className="mt-20 font-mono-accent text-[11px] uppercase tracking-[0.25em] text-white/40">
        {t.philosophy.constant}
      </p>

      <div className="mt-8 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/[0.04] md:grid-cols-3">
        {principles.map((p, i) => (
          <motion.article
            key={p.num}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            data-testid={`principle-${p.num}`}
            className="group bg-[#080809] p-8 transition-colors duration-500 hover:bg-[#0d0d10] sm:p-10"
          >
            <span className="chapter-num text-6xl text-white/10 transition-colors duration-500 group-hover:text-[#a855f7]/40 sm:text-7xl">
              {p.num}
            </span>
            <p className="mt-10 font-head text-xl font-medium leading-snug tracking-tight text-white">
              {p.text}
            </p>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
